var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M6,0A6,6,0,1,1,0,6,6.007,6.007,0,0,1,6,0ZM6,.878A5.122,5.122,0,1,0,11.122,6,5.128,5.128,0,0,0,6,.878Zm-.245,3.08C6.059,4.085,8.2,5.179,8.2,6c0,.767-1.922,1.839-2.413,2.044a1.678,1.678,0,0,1-.614.155.585.585,0,0,1-.43-.167c-.094-.093-.346-.342-.347-1.98,0-1.74.261-2,.347-2.084C5.043,3.661,5.542,3.869,5.755,3.958Z",
    fill: "#1b2737",
    fillRule: "evenodd",
    opacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallPlayIcon);
export default __webpack_public_path__ + "static/media/smallPlayIcon.53c0a6d6feea5fde80f67df8ea66a34f.svg";
export { ForwardRef as ReactComponent };